module.exports = __webpack_public_path__ + "summary.png?cf6bd6cf497c8eeeb813e615d7f2d6c4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/summary.png
// module id = 751
// module chunks = 0